var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacebookSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 17V9.456H9V6.104H6.3V4.427c0-1.074.206-1.673.9-1.676H9V.236C8.95.004 8.017 0 6.3 0 4.233 0 2.54 1.338 2.7 3.589v2.515H0v3.352h2.7V17h3.6z",
    fill: "#0A3F46",
    fillRule: "evenodd"
  })));
}

export default SvgIconFacebookSimple;